<template>
  <!-- 维修站授权绑定 -->
  <div class="register-page ">
    <!-- <div class="notice-bar">
      <div class="notice-bar-info">提示：您的手机号暂无关联的易加网账号，请注册新账号并授权绑定</div>
    </div>
    <div class="content">
      <van-form @submit="onSubmit" :show-error="false">
        <van-field v-model="clientInfo.clientName" name="维修站名称" label="维修站名称" placeholder="点击填写维修站名称"
          :rules="[{ required: true, message: '请输入维修站名称' }]" disabled />
        <van-field v-model="clientInfo.detailAddress" name="维修站地址" label="维修站地址" placeholder="点击填写维修站地址"
          :rules="[{ required: true, message: '请输入维修站地址' }]" disabled />
        <van-field :value="clientInfo.contactMobile + '(' + clientInfo.contactPerson + ')'" name="维修站老板手机号"
          label="维修站老板手机号" :rules="[{ required: true, message: '维修站老板手机号' }]" disabled></van-field>
        <van-field v-model="kongzTokenDTO.name" name="name" label="姓名" placeholder="点击填写姓名"
          :rules="[{ required: true, message: '请输入姓名' }]" disabled />
        <van-field v-model="kongzTokenDTO.phone" name="phone" label="手机号" placeholder="点击填写手机号" disabled
          :rules="[{ required: true, message: '请输入手机号' }]">
        </van-field>
        <div class="confirmButton">
          <van-button  block type="primary" native-type="submit">确认{{ fixedButtonText }}
          </van-button>
        </div>
      </van-form>
    </div> -->
  </div>
</template>

<script>
// import countdownButton from './countdown-button.vue'
import validators from '@/utils/validators'
import { kangzhongApi } from '@/api/bind'
export default {
  components: {
    // countdownButton
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => { }
    },
    kongzTokenDTO: {
      type: Object,
      default: () => { }
    },
    fixedButtonText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      verifyCode: '' // 验证码
    }
  },
  computed: {},
  mounted () {
    this.onSubmit()
  },
  methods: {
    // 验证确认密码
    validatorPassword (val) {
      return this.password === val
    },
    validatorPhone (val) {
      return validators.checkMobile(val)
    },
    getCode (phone) {
      if (!this.$refs.countDown.isGeting && phone.trim()) {
        kangzhongApi.getVerifyCode({ phone: phone.trim() }).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('已发送验证码')
            this.$refs.countDown.startDown()
          }
        })
      }
    },
    onSubmit () {
      let data = {
        uuid: this.kongzTokenDTO.uuid,
        phone: this.kongzTokenDTO.phone,
        name: this.kongzTokenDTO.name,
        // verifyCode: this.verifyCode,
        clientName: this.clientInfo.clientName,
        detailAddress: this.clientInfo.detailAddress,
        provinceName: this.clientInfo.provinceName,
        cityName: this.clientInfo.cityName,
        countyName: this.clientInfo.countyName,
        userRole: this.kongzTokenDTO.userRole,
        clientCode: this.clientInfo.clientCode
      }
      this.$emit('submit', data)
    }
  }
}
</script>
<style  scoped lang="less">
.register-page {
  .content {
    background-color: #fff;
  }

  .van-cell {
    background-color: #fff;

    /deep/ .van-field__label {
      width: 100%;
    }
  }
}

.confirmButton {
  padding: 0.5rem;
}
</style>
